module.exports = __webpack_public_path__ + "img/ErrorImg.d0b70a81.png";